import React from "react";
import { RiskStatusIcon, Section, Tooltip } from "@sscs/ui";
import { PendingActionsIcon } from "@sscs/ui/icons";
import { ALL_RISKS_PASSED_LABEL, ASSESSMENT_SUPERCATEGORY, ASSESSMENT_SUPERCATEGORY_TYPES, ASSESSMENT_TYPE_TO_TITLE, } from "../../../constants";
import { AssessmentCategory } from "../../index";
import RenderChildrenWrapper from "../RenderChildrenWrapper";
import styles from "./riskStatistics.module.scss";
const getRiskSummary = (risk) => {
    let finalAssessment = undefined;
    const otherAssessments = [];
    Object.keys(risk).forEach((assessmentType) => {
        if (risk[assessmentType].final) {
            finalAssessment = assessmentType;
        }
        else if (risk[assessmentType].count > 0) {
            otherAssessments.push(assessmentType);
        }
    });
    return {
        finalAssessment,
        otherAssessments,
    };
};
const AssessmentBreakdown = ({ risk, risksCountWrapper, }) => (React.createElement("div", { className: styles["assessment-breakdown"] }, Object.keys(ASSESSMENT_SUPERCATEGORY_TYPES).map((superCategory) => {
    const riskCategories = ASSESSMENT_SUPERCATEGORY_TYPES[superCategory];
    return (React.createElement(React.Fragment, { key: superCategory },
        React.createElement(Section, { className: styles["assessment-group"] },
            React.createElement(Section.Title, { as: "h3" }, ASSESSMENT_SUPERCATEGORY[superCategory])),
        riskCategories.map((riskCategory) => (React.createElement(AssessmentCategory, { key: riskCategory, variant: "inline", riskCategory: riskCategory, risk: risk[riskCategory], risksCountWrapper: risksCountWrapper })))));
})));
const RiskStatistics = ({ risk, showStatusIcon = true, riskCountWrapper, viewReportWrapper, }) => {
    var _a, _b, _c, _d;
    const riskSummary = risk ? getRiskSummary(risk) : undefined;
    const finalRisk = risk && (riskSummary === null || riskSummary === void 0 ? void 0 : riskSummary.finalAssessment)
        ? risk[riskSummary.finalAssessment]
        : undefined;
    if (!risk || !riskSummary) {
        return (React.createElement("div", { className: styles["risk-statistics"] },
            React.createElement(PendingActionsIcon, { className: styles["pending-icon"] }),
            React.createElement("span", null, "Pending")));
    }
    if (!(finalRisk === null || finalRisk === void 0 ? void 0 : finalRisk.count) || !riskSummary.finalAssessment) {
        return (React.createElement("div", { className: styles["risk-statistics"] },
            showStatusIcon && (React.createElement(RiskStatusIcon, { status: (_a = finalRisk === null || finalRisk === void 0 ? void 0 : finalRisk.status) !== null && _a !== void 0 ? _a : "pass", disabled: !((_b = finalRisk === null || finalRisk === void 0 ? void 0 : finalRisk.enabled) !== null && _b !== void 0 ? _b : true) })),
            React.createElement("span", null, ALL_RISKS_PASSED_LABEL)));
    }
    return (React.createElement("div", { className: styles["risk-statistics"] },
        showStatusIcon && (React.createElement(RiskStatusIcon, { status: (_c = finalRisk === null || finalRisk === void 0 ? void 0 : finalRisk.status) !== null && _c !== void 0 ? _c : "pass", disabled: !((_d = finalRisk === null || finalRisk === void 0 ? void 0 : finalRisk.enabled) !== null && _d !== void 0 ? _d : true) })),
        React.createElement("div", null,
            React.createElement("span", null,
                React.createElement("strong", null,
                    ASSESSMENT_TYPE_TO_TITLE[riskSummary.finalAssessment],
                    ":"),
                " ",
                React.createElement(RenderChildrenWrapper, { wrapper: riskCountWrapper &&
                        ((children) => riskCountWrapper(finalRisk, riskSummary.finalAssessment, children)) }, finalRisk.count.toLocaleString()),
                " ",
                React.createElement("span", null, finalRisk.label)),
            riskSummary.otherAssessments.length > 0 && (React.createElement("div", { className: styles["extra-risks"] },
                "+",
                React.createElement(Tooltip, { trigger: "term", tooltipType: "card", fitContent: true, header: React.createElement(React.Fragment, null,
                        React.createElement("span", null, "SAFE assessment"),
                        viewReportWrapper &&
                            viewReportWrapper(React.createElement("div", null, "View report"))), title: React.createElement(AssessmentBreakdown, { risk: risk, risksCountWrapper: riskCountWrapper }) },
                    React.createElement("small", null, riskSummary.otherAssessments
                        .map((assessment) => ASSESSMENT_TYPE_TO_TITLE[assessment])
                        .join(", "))),
                " ",
                "risk",
                Object.keys(riskSummary.otherAssessments).length === 1 ? "" : "s")))));
};
export default RiskStatistics;
//# sourceMappingURL=RiskStatistics.js.map